import { render } from "./Passcode.vue?vue&type=template&id=f1d8df7c&ts=true"
import script from "./Passcode.vue?vue&type=script&lang=ts"
export * from "./Passcode.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__